import { GitBranchIcon, LockKeyIcon, ProhibitIcon, ShieldCheckIcon } from '@phosphor-icons/react';
import type { AnalysisReport } from '../types';

interface SocialPreviewProps {
  readonly report: AnalysisReport | null;
  readonly selectedPath: string;
}

export function SocialPreview({ report, selectedPath }: SocialPreviewProps) {
  const selected = report?.paths.find((path) => path.path === selectedPath);
  const rules = report?.rules.filter((rule) => rule.kind === 'pattern').slice(0, 7) ?? [];
  const paths = report?.paths.filter((path) => path.kind === 'file').slice(0, 8) ?? [];

  return (
    <main className="social-preview" data-ready={report ? 'true' : 'false'}>
      <header className="social-brand">
        <span className="social-mark">
          <GitBranchIcon aria-hidden="true" />
        </span>
        <div>
          <h1>WhatTheIgnore</h1>
          <p>See exactly why Git ignores a file.</p>
        </div>
        <span className="social-privacy">
          <LockKeyIcon aria-hidden="true" /> Local-only
        </span>
      </header>
      <section className="social-workbench">
        <div className="social-panel social-rules">
          <h2>Rules</h2>
          {rules.map((rule) => (
            <div
              className={rule.statuses.includes('Blocked negation') ? 'is-warning' : ''}
              key={rule.id}
            >
              <span>{rule.line}</span>
              <code>{rule.raw}</code>
              <small>{rule.status}</small>
            </div>
          ))}
        </div>
        <div className="social-panel social-files">
          <h2>Files</h2>
          {paths.map((path) => (
            <div className={path.path === selectedPath ? 'is-selected' : ''} key={path.path}>
              <code>{path.path}</code>
              <small>{path.ignored ? 'Ignored' : 'Tracked'}</small>
            </div>
          ))}
        </div>
        <div className="social-panel social-why">
          <h2>Why?</h2>
          <code className="social-path">{selected?.path ?? selectedPath}</code>
          <span className="social-result">
            <ProhibitIcon aria-hidden="true" /> Ignored
          </span>
          <strong>Blocked negation</strong>
          <p>
            The parent directory is ignored. Git cannot re-include this file until the directory is
            restored first.
          </p>
          <div className="social-decision">
            <span>Decisive rule</span>
            <code>{selected?.decisiveRule?.raw ?? 'src/generated/'}</code>
            <small>
              {selected?.ruleSource ?? '.gitignore'}:{selected?.ruleLine ?? 8}
            </small>
          </div>
        </div>
      </section>
      <footer className="social-footer">
        <span>
          <ShieldCheckIcon aria-hidden="true" /> No uploads. No analytics. No account.
        </span>
        <span>what-the-ignore</span>
      </footer>
    </main>
  );
}
